// import { Component, OnInit } from '@angular/core';
// import { UmsService } from '../ums.service';
// import { HttpErrorResponse } from '@angular/common/http';
// import { NgxSpinnerService } from 'ngx-spinner';

// @Component({
//   selector: 'app-uni-suit-pay',
//   templateUrl: './uni-suit-pay.component.html',
//   styleUrls: ['./uni-suit-pay.component.scss']
// })
// export class UniSuitPayComponent implements OnInit {
//   PayDetails: any;
//   reqstNarration: any;
//   FeeHeadUniSuite: any;
//   StuFullName: any;
//   studentmail: any;
//   stuMobileNo: any;
//   oldStuid: any;
//   StuFullNamePersonal: any;

//   constructor(public umsService: UmsService, private spinner: NgxSpinnerService,) { }
//   FirstName: string
//   MiddleName: string
//   LastName: string
//   Number
//   Email: string
//   ngOnInit(): void {
//     this.PayDetails = this.umsService.getpayDetails();
//     this.getUserData(sessionStorage.getItem('StudentRGID'));
//     // this.getPersonalDetails();
//     // this.gettranscriptDetails();
//   }

//   generateTxnNumber(): string {
//     const digits = '0123456789';
//     const otpLength = 15;  // The length of the transaction number
//     let otp = '';

//     for (let i = 0; i < otpLength; i++) {
//       const index = Math.floor(Math.random() * digits.length);
//       otp += digits[index];
//     }

//     return otp;
//   }

//   getUserData(id) {
//     this.spinner.show()
//     this.FirstName = sessionStorage.getItem('StuFirstName');
//     this.MiddleName = sessionStorage.getItem('StuMidName');
//     this.LastName = sessionStorage.getItem('StuLastName');
//     this.Number = sessionStorage.getItem('StuMobNumber');
//     this.Email = sessionStorage.getItem('StuEmailId');

//     this.umsService.getUserData(id).subscribe((res) => {
//       if (res.status) {
//         this.spinner.hide();
//         this.FirstName = res.data[0][0]['StuFirstName']
//         this.MiddleName = res.data[0][0]['StuMidName']
//         this.LastName = res.data[0][0]['StuLastName']
//         this.Number = parseInt(res.data[0][0]['StuMobNumber'])
//         this.Email = res.data[0][0]['StuEmailId']
//         this.gettranscriptDetails(this.PayDetails);
//         this.getPersonalDetails();
//         // this.getNewForm(this.PayDetails);
//       }
//       else {
//         this.spinner.hide();
//       }
//     }, (ERROR: HttpErrorResponse) => {
//       this.spinner.hide()
//     });
//   }

//   getNewForm(data,) {
//     let receiptHeads = data.paydata.item.feeHeadArray.map(item => {
//       return `445~${item.FeeAmt}`;  // Directly use FeeHead value (like "ADM")
//     }).join(',');
//     // let stuFullname = studentData.StuFirstName + " " + studentData.StuMidName + " " + studentData.StuLastName;
//     this.reqstNarration = "";
//     this.FeeHeadUniSuite = "";

//     if (data.paydata.FeeType == "AF") {
//       this.reqstNarration = "Admission Fee"
//       this.FeeHeadUniSuite = '1871~' + data.paydata.PaidAmount
//     }
//     else if (data.paydata.FeeType == "ASC") {
//       this.reqstNarration = "Photocopy Of Answer Sheet"
//       this.FeeHeadUniSuite = '446~' + data.paydata.PaidAmount
//     }
//     else if (data.paydata.FeeType == "EF") {
//       if (data.paydata.item && data.paydata.item.feeHeadArray && Array.isArray(data.paydata.item.feeHeadArray)) {
//         let feeHeads = [];
//         let narrations = [];

//         data.paydata.item.feeHeadArray.forEach(fee => {
//           if (fee.FeeHead === "51") {
//             feeHeads.push('459~' + fee.FeeDue);
//             narrations.push("Cap Charges");
//           }
//           else if (fee.FeeHead === "52") {
//             feeHeads.push('442~' + fee.FeeDue);
//             narrations.push("Passing certification Fee");
//           }
//           else if (fee.FeeHead === "53") {
//             feeHeads.push('444~' + fee.FeeDue);
//             narrations.push("Degree Certificate Fees");
//           }
//           else {
//             feeHeads.push('437~' + fee.FeeDue);
//             narrations.push("Examination Fee");
//           }
//         });
//         this.FeeHeadUniSuite = feeHeads.join(',');
//         this.reqstNarration = narrations.join(' & ');
//       } else {
//         this.reqstNarration = "Examination Fee"
//         this.FeeHeadUniSuite = '437~' + data.paydata.PaidAmount
//       }
//     }
//     else if (data.paydata.FeeType == "TS") {
//       this.reqstNarration = "Transcript Fee"
//       this.FeeHeadUniSuite = '445~' + data.paydata.PaidAmount
//     }
//     else if (data.paydata.FeeType == "TC") {
//       this.reqstNarration = "Transfer Certificate Fee"
//       this.FeeHeadUniSuite = '1881~' + data.paydata.PaidAmount
//     }
//     else if (data.paydata.FeeType == "LC") {
//       this.reqstNarration = "Leaving Certificate Fee"
//       this.FeeHeadUniSuite = ''
//     }
//     else if (data.paydata.FeeType == "MC") {
//       this.reqstNarration = "Migration Certificate Fee"
//       this.FeeHeadUniSuite = '6~' + data.paydata.PaidAmount
//     }
//     else {
//       this.reqstNarration = "Fee"
//       this.FeeHeadUniSuite = ''
//     }

//     console.log("Fee Head UniSuite:", this.FeeHeadUniSuite);
//     console.log("Narration:", this.reqstNarration);

//     const payload = {};
//     payload["reqstNumber"] = this.generateTxnNumber();
//     payload["reqstSourceID"] = "1";
//     payload["txnAmount"] = data.paydata.PaidAmount;
//     //payload["returnURL"] = "http://213.199.57.102:4003/api/v1/uniSuitePayment/receipt-response"; //UAT
//     // payload["returnURL"] = "http://muhsems.ac.in:3003/api/v1/uniSuitePayment/receipt-response"; //Prod
//     payload["returnURL"] = "http://api.muhsems.ac.in/api/v1/uniSuitePayment/receipt-response"; //Prod
//     payload["reqstNarration"] = this.reqstNarration;
//     payload["receiptHeads"] = this.FeeHeadUniSuite; // Will be: '437~3640,4244~800'
//     payload["sectionCode"] = "5030";
//     payload["isAided"] = false;
//     payload["entityType"] = "";
//     payload["entityCode"] = data.paydata.CgCode; //college code
//     payload["receiveFromTitle"] = this.StuFullName || this.StuFullNamePersonal;
//     payload["enrollmentNo"] = data.paydata.StuId != undefined ? data.paydata.StuId : parseInt(sessionStorage.getItem('StudentRGID'));
//     payload["mobileNo"] = this.stuMobileNo;
//     payload["IsMobileNoVerified"] = false;
//     payload["emailID"] = this.studentmail;
//     payload["IsEmailIDVerified"] = false;
//     payload["isAllowNEFTRTGS"] = false;
//     payload["isAllowPG"] = true;
//     payload["payExpiry"] = "";
//     payload["addressLine1"] = "";
//     payload["addressLine2"] = "";
//     payload["cityName"] = "";
//     payload["zipCode"] = "";
//     payload["stateName"] = "";
//     payload["countryName"] = "";
//     payload["udf1"] = data.paydata.StuId != undefined ? data.paydata.StuId : parseInt(sessionStorage.getItem('StudentRGID'));
//     payload["udf2"] = data.paydata.FeeTemplateCode;
//     payload["udf3"] = data.paydata.FeeType;
//     payload["udf4"] = data.paydata.SnNo;
//     payload["udf5"] = "";
//     payload["udf6"] = "";
//     payload["udf7"] = "";
//     payload["udf8"] = "";
//     payload["udf9"] = "";
//     payload["udf10"] = "";

//     console.log(payload, "Final Payload");
//     // return
//     this.umsService.receiptRequest(payload).subscribe((res) => {
//       if (res.status) {
//         const formHtml = res.data;
//         this.submitForm(formHtml);
//       }
//       else {
//       }
//     }, (ERROR: HttpErrorResponse) => {

//     })
//   }


//   submitForm(formHtml: string) {
//     // Create a new div element to store the form HTML

//     const div = document.createElement('div');
//     div.innerHTML = formHtml;
//     // Append the div to the body (or another part of your DOM)
//     document.body.appendChild(div);
//     // Find the form inside the div
//     const form = div.querySelector('form');
//     if (form) {
//       form.submit();  // Automatically submit the form
//     } else {
//     }
//   }

//   getPersonalDetails() {
//     let payload = {};
//     payload['StuRgNo'] = sessionStorage.getItem('StudentRGID');;
//     this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
//       this.oldStuid = res.data[0].StuId;
//       // this.StuFullName = res.data[0].StudentName || res.data[0].StuFullNameEng;
//       this.StuFullNamePersonal = res?.data?.[0]?.StudentName || res?.data?.[0]?.StuFullNameEng || '';
//       // this.studentmail = res.data[0].EmailID;
//       // this.stuMobileNo = res.data[0].StuNumber;
//       this.getNewForm(this.PayDetails);
//       // this.gettranscriptDetails()
//     });

//   }

//   gettranscriptDetails(data) {
//     let receiptHeads = data.paydata.item.feeHeadArray.map(item => {
//       return `445~${item.FeeAmt}`;  // Directly use FeeHead value (like "ADM")
//     }).join(',');
//     let payload = {};
//     payload['StuId'] = data.paydata.StuId != undefined ? data.paydata.StuId : parseInt(sessionStorage.getItem('StudentRGID')),
//       this.umsService.SearchTranscript(payload).subscribe((res) => {
//         console.log('res.data', res.data);
//         this.StuFullName = res.data[0].StuName;
//         this.studentmail = res.data[0].StuEmail;
//         this.stuMobileNo = res.data[0].StuPhone;
//         this.getNewForm(this.PayDetails)

//       });

//   }
// }
import { Component, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-uni-suit-pay',
  templateUrl: './uni-suit-pay.component.html',
  styleUrls: ['./uni-suit-pay.component.scss']
})
export class UniSuitPayComponent implements OnInit {
  PayDetails: any;
  reqstNarration: any;
  FeeHeadUniSuite: any;
  StuFullName: any;
  studentmail: any;
  stuMobileNo: any;
  oldStuid: any;
  StuFullNamePersonal: any;

  constructor(public umsService: UmsService, private spinner: NgxSpinnerService,) { }
  FirstName: string
  MiddleName: string
  LastName: string
  Number
  Email: string
  ngOnInit(): void {
    this.PayDetails = this.umsService.getpayDetails();
    this.getUserData(sessionStorage.getItem('StudentRGID'));
    // this.getPersonalDetails();
    // this.gettranscriptDetails();
  }

  generateTxnNumber(): string {
    const digits = '0123456789';
    const otpLength = 15;  // The length of the transaction number
    let otp = '';

    for (let i = 0; i < otpLength; i++) {
      const index = Math.floor(Math.random() * digits.length);
      otp += digits[index];
    }

    return otp;
  }

  getUserData(id) {
    this.spinner.show()
    this.FirstName = sessionStorage.getItem('StuFirstName');
    this.MiddleName = sessionStorage.getItem('StuMidName');
    this.LastName = sessionStorage.getItem('StuLastName');
    this.Number = sessionStorage.getItem('StuMobNumber');
    this.Email = sessionStorage.getItem('StuEmailId');

    this.umsService.getUserData(id).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.FirstName = res.data[0][0]['StuFirstName']
        this.MiddleName = res.data[0][0]['StuMidName']
        this.LastName = res.data[0][0]['StuLastName']
        this.Number = parseInt(res.data[0][0]['StuMobNumber'])
        this.Email = res.data[0][0]['StuEmailId']
        this.gettranscriptDetails(this.PayDetails);
        this.getPersonalDetails();
        // this.getNewForm(this.PayDetails);
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  getNewForm(data,) {
    // alert("Data received for UniSuite Payment: " + JSON.stringify(data));
    let receiptHeads = data.paydata.item.feeHeadArray.map(item => {
      return `445~${item.FeeAmt}`;  // Directly use FeeHead value (like "ADM")
    }).join(',');
    // let stuFullname = studentData.StuFirstName + " " + studentData.StuMidName + " " + studentData.StuLastName;
    this.reqstNarration = "";
    this.FeeHeadUniSuite = "";

    if (data.paydata.FeeType == "AF") {
      this.reqstNarration = "Admission Fee"
      this.FeeHeadUniSuite = '1871~' + data.paydata.PaidAmount
    }
    else if (data.paydata.FeeType == "ASC") {
      this.reqstNarration = "Photocopy Of Answer Sheet"
      this.FeeHeadUniSuite = '446~' + data.paydata.PaidAmount
    }
     else if (data.paydata.FeeType == "RET") {
      this.reqstNarration = "Recruitment-Verification Of Marks / Retotal"
      this.FeeHeadUniSuite = '1560~' + data.paydata.PaidAmount
    }
    else if (data.paydata.FeeType == "LANG") {
      this.reqstNarration = "Language Certificate"
      this.FeeHeadUniSuite = '33~' + data.paydata.PaidAmount
    }
    else if (data.paydata.FeeType == "ATTFE") {
      this.reqstNarration = "Attestation Fee"
      this.FeeHeadUniSuite = '321~' + data.paydata.PaidAmount
    }
    else if (data.paydata.FeeType == "VOD") {
      this.reqstNarration = "Verification of University Document"
      this.FeeHeadUniSuite = '439~' + data.paydata.PaidAmount
    }
    else if (data.paydata.FeeType == "EF") {
      if (data.paydata.item && data.paydata.item.feeHeadArray && Array.isArray(data.paydata.item.feeHeadArray)) {
        let feeHeads = [];
        let narrations = [];

        data.paydata.item.feeHeadArray.forEach(fee => {
          if (fee.FeeHead === "51") {
            feeHeads.push('459~' + fee.FeeDue);
            narrations.push("Cap Charges");
          }
          else {
            feeHeads.push('437~' + fee.FeeDue);
            narrations.push("Examination Fee");
          }
        });
        this.FeeHeadUniSuite = feeHeads.join(',');
        this.reqstNarration = narrations.join(' & ');
      } else {
        this.reqstNarration = "Examination Fee"
        this.FeeHeadUniSuite = '437~' + data.paydata.PaidAmount
      }
    }
    else if (data.paydata.FeeType == "TS") {
      this.reqstNarration = "Transcript Fee"
      this.FeeHeadUniSuite = '445~' + data.paydata.PaidAmount
    }
    else if (data.paydata.FeeType == "TC") {
      this.reqstNarration = "Transfer Certificate Fee"
      this.FeeHeadUniSuite = '1881~' + data.paydata.PaidAmount
    }
    else if (data.paydata.FeeType == "LC") {
      this.reqstNarration = "Leaving Certificate Fee"
      this.FeeHeadUniSuite = ''
    }
    else if (data.paydata.FeeType == "MC") {
      this.reqstNarration = "Migration Certificate Fee"
      this.FeeHeadUniSuite = '6~' + data.paydata.PaidAmount
    }
    else {
      this.reqstNarration = "Fee"
      this.FeeHeadUniSuite = ''
    }

    console.log("Fee Head UniSuite:", this.FeeHeadUniSuite);
    console.log("Narration:", this.reqstNarration);

    const payload = {};
    payload["reqstNumber"] = this.generateTxnNumber();
    payload["reqstSourceID"] = "1";
    payload["txnAmount"] = data.paydata.PaidAmount;
    // payload["returnURL"] = "http://213.199.57.102:4003/api/v1/uniSuitePayment/receipt-response"; //UAT
    payload["returnURL"] = "http://169.58.219.120:4003/api/v1/uniSuitePayment/receipt-response"; //UAT
    // payload["returnURL"] = "http://muhsems.ac.in:3003/api/v1/uniSuitePayment/receipt-response"; //Prod
    payload["reqstNarration"] = this.reqstNarration;
    payload["receiptHeads"] = this.FeeHeadUniSuite; // Will be: '437~3640,4244~800'
    payload["sectionCode"] = "5030";
    payload["isAided"] = false;
    payload["entityType"] = "";
    // payload["entityCode"] = data.paydata.CgCode;
    payload["entityCode"] = "";
    payload["receiveFromTitle"] = this.StuFullName || this.StuFullNamePersonal;
    payload["enrollmentNo"] = data.paydata.StuId != undefined ? data.paydata.StuId : parseInt(sessionStorage.getItem('StudentRGID'));
    payload["mobileNo"] = this.stuMobileNo;
    payload["IsMobileNoVerified"] = false;
    payload["emailID"] = this.studentmail;
    payload["IsEmailIDVerified"] = false;
    payload["isAllowNEFTRTGS"] = false;
    payload["isAllowPG"] = true;
    payload["payExpiry"] = "";
    payload["addressLine1"] = "";
    payload["addressLine2"] = "";
    payload["cityName"] = "";
    payload["zipCode"] = "";
    payload["stateName"] = "";
    payload["countryName"] = "";
    payload["udf1"] = data.paydata.StuId != undefined ? data.paydata.StuId : parseInt(sessionStorage.getItem('StudentRGID'));
    payload["udf2"] = data.paydata.FeeTemplateCode;
    payload["udf3"] = data.paydata.FeeType;
    payload["udf4"] = data.paydata.SnNo;
    payload["udf5"] = data.paydata.SelectedHeadIds ? data.paydata.SelectedHeadIds.join(',') : '';
    payload["udf6"] = "";
    payload["udf7"] = "";
    payload["udf8"] = "";
    payload["udf9"] = "";
    payload["udf10"] = "";

    //alert("Payload for UniSuite Payment: " + JSON.stringify(payload));
    this.umsService.receiptRequest(payload).subscribe((res) => {

      if (res.status) {
        const formHtml = res.data;

        this.submitForm(formHtml);
      }
      else {
      }
    }, (ERROR: HttpErrorResponse) => {

    })
  }


  submitForm(formHtml: string) {
    // Create a new div element to store the form HTML

    const div = document.createElement('div');
    div.innerHTML = formHtml;
    // Append the div to the body (or another part of your DOM)
    document.body.appendChild(div);
    // Find the form inside the div
    const form = div.querySelector('form');
    if (form) {
      form.submit();  // Automatically submit the form
    } else {
    }
  }

  getPersonalDetails() {
    let payload = {};
    payload['StuRgNo'] = sessionStorage.getItem('StudentRGID');;
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      this.oldStuid = res.data[0].StuId;
      // this.StuFullName = res.data[0].StudentName || res.data[0].StuFullNameEng;
      this.StuFullNamePersonal = res?.data?.[0]?.StudentName || res?.data?.[0]?.StuFullNameEng || '';
      // this.studentmail = res.data[0].EmailID;
      // this.stuMobileNo = res.data[0].StuNumber;
      this.getNewForm(this.PayDetails);
      // this.gettranscriptDetails()
    });

  }

  gettranscriptDetails(data) {
    let receiptHeads = data.paydata.item.feeHeadArray.map(item => {
      return `445~${item.FeeAmt}`;  // Directly use FeeHead value (like "ADM")
    }).join(',');
    let payload = {};
    payload['StuId'] = data.paydata.StuId != undefined ? data.paydata.StuId : parseInt(sessionStorage.getItem('StudentRGID')),
      this.umsService.SearchTranscript(payload).subscribe((res) => {
        console.log('res.data', res.data);
        this.StuFullName = res.data[0].StuName;
        this.studentmail = res.data[0].StuEmail;
        this.stuMobileNo = res.data[0].StuPhone;
        this.getNewForm(this.PayDetails)

      });

  }
}
